import { UserRole } from 'enums';
import { messages } from 'i18n';
import SetEndUserPage from 'broker/pages/SetEndUserPage';

export default function PlacementServicesPage() {
  return (
    <SetEndUserPage
      title={messages.placementServicesPage.title}
      selectPlaceholder={messages.placementServicesPage.selectPlaceholder}
      signOutText={messages.placementServicesPage.signOutText}
      setUserText={messages.placementServicesPage.setUserText}
      searchUserFilter={{
        role: UserRole.Retailer,
        isDirectPlacement: true,
        enabled: true,
      }}
    />
  );
}
